import { useEffect } from "react";
import PropTypes from "prop-types";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";

// initialConfig.editable is read once when the editor is created, so a later
// change to the readOnly prop has to be pushed onto the editor here.
function EditablePlugin({ readOnly }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(!readOnly);
  }, [editor, readOnly]);

  return null;
}

EditablePlugin.propTypes = {
  readOnly: PropTypes.bool,
};

export default EditablePlugin;
